import { GET_WEEK_REPORT, ERROR, IS_LOADING } from "./activityReportConstants";
import { fetchWithTimeout } from "../../lib/fetch_wrapper";
import { throwErrorMessage } from "../../lib/error_helper";

export function reportFetchData(empId) {
    return (dispatch) => {
        dispatch(activityReportIsLoading(true));
        const headers = new Headers({ "Content-Type": "application/json" });
        // const body = JSON.stringify({emp_id: empId});
        fetchWithTimeout("/api/v2/get_report/" + empId, {
            method: "GET",
            headers: headers,
        })
            .then((response) => {
                dispatch(activityReportIsLoading(false));

                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then((response) => response.json())
            .then((activityReports) => dispatch(activityReportFetchDataSuccess(activityReports)))
            .catch((err) => {
                console.error("Erreur : activityReportActions - reportFetchData");
                dispatch(
                    throwErrorMessage({
                        errorObject: err,
                        title: "Erreur",
                        message: "Erreur lors de la récupération des activités !",
                    })
                );
                dispatch(activityReportHasErrored(err));
                dispatch(activityReportIsLoading(false));
            });
    };
}

export function activityReportIsLoading(bool) {
    return {
        type: IS_LOADING,
        info: "Récupération du rapport d'activité",
        isLoading: bool,
    };
}

export function activityReportHasErrored(error) {
    return {
        type: ERROR,
        info: "Récupération du rapport d'activité",
        error: error,
    };
}

export function activityReportFetchDataSuccess(activityReports) {
    return {
        type: GET_WEEK_REPORT,
        payload: activityReports,
    };
}
